import { isLoggedIn, gotSessionToken } from "../../utils/auth";
import { redirectTo } from "@reach/router";

export const AuthenticatedRoute = ({ children }) => {
  if (!isLoggedIn() && gotSessionToken() !== null) {
    redirectTo("/login");
  }
  return children;
};
